(function (angular, app) {
    'use strict';

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.categoryProducts', {
                url: '/categories/:cid/products?{filters:json}&{sort:json}&{events:json}&page',
                data: {
                    name: 'category-products'
                },
                reloadOnSearch: false,
                resolve: {
                    categories: ['$rootScope','$state', '$stateParams', 'Util', function ($rootScope,$state, $stateParams, util) {
                        return util.getCategory($stateParams.cid).then(function(categories) {
                            if (categories) {
                                $rootScope.$emit('categoryPage',categories);
                            }
                            return categories || [];
                        });
                    }]
                },
                metaTags: {
                    title: ['$filter', 'categories', function($filter, categories) {
                        if (categories && categories.length) {
                            return $filter('name')(categories[0].names);
                        }
                    }],
                    description: ['$filter', 'categories', function ($filter, categories) {
                        if (!categories || !categories.length) {
                            return;
                        }

                        for (var i = 0; i < categories.length; i++) {
                            if (categories[i].description) {
                                return categories[i].description;
                            }
                        }

                        return $filter('name')(categories[0].names);
                    }],
                    keywords: ['$filter', 'categories', function ($filter, categories) {
                        if (!categories || !categories.length) {
                            return;
                        }

                        for (var i = 0; i < categories.length; i++) {
                            if (categories[i].keywords) {
                                return categories[i].keywords;
                            }
                        }

                        return $filter('name')(categories[0].names);
                    }]
                },
                views: {
                    '@': {
                        templateUrl: 'template/views/category-products/index.html',
                        controller: 'CategoryProductsCtrl as categoryCtrl'
                    }
                }
            });
        }])
        .controller('CategoryProductsCtrl', [
            '$scope', '$rootScope', '$filter', '$q', '$state', '$stateParams', '$location', '$timeout', 'Api', 'Util', 'Items',
            'Cart', 'FilterManager', 'User', 'categories', 'CATEGORIES_TYPES', 'ADVERTISEMENT_CONVERSION_TYPE', 'Config', 'DataLayer',
            function ($scope, $rootScope, $filter, $q, $state, $stateParams, $location, $timeout, api, util, Items,
                      cart, FilterManager, User, categories, CATEGORIES_TYPES, ADVERTISEMENT_CONVERSION_TYPE, Config, DataLayer) {
                var categoryCtrl = this;

                var roboticBranchOrderSettings = Config.getCurrentBranchRoboticOrderHandlingSettings();

                $rootScope.roboticBranchOrderSettings = roboticBranchOrderSettings;

                var _isRetailerPremiumReplacementsEnabled = Config.retailer.settings.enablePersonalReplacement;

                function _getPageFromUrl() {
                    var match = window.location.search.match(/[?&]page=(\d+)/);
                    return match ? parseInt(match[1], 10) : 1;
                }

                var _currentCid = String($stateParams.cid);
                var _isCategorySwitch = $rootScope._lastCategoryProductsCid &&
                    String($rootScope._lastCategoryProductsCid) !== _currentCid;
                var _currentPage = _isCategorySwitch ? 1 : (parseInt($stateParams.page, 10) || _getPageFromUrl() || 1);
                var _deeplinkPage = _currentPage;
                var _catalogOffsetBase = null;
                var _shouldScrollToPage = _currentPage > 1;
                var _prependInFlight = false;
                var _paginationChunkSize = null;
                var _urlPageSyncTimeout = null;
                var _urlUpdateTimer = null;
                var _TOP_SCROLL_LOAD_THRESHOLD = 500;
                var _lastScrollTop = 0;
                var _isEmptyPreviousRequest = false;
                var _uidCounter = 0;
                var _isInitialLoadComplete = false;

                $rootScope._lastCategoryProductsCid = _currentCid;

                if (_isCategorySwitch) {
                    delete $rootScope._categoryProductsPaginationPage;
                } else if (_currentPage > 1) {
                    $rootScope._categoryProductsPaginationPage = _currentPage;
                }
                
                function _assignUniqueIds(products) {
                    for (var i = 0; i < products.length; i++) {
                        if (!products[i]._uid) {
                            products[i]._uid = 'p_' + (++_uidCounter) + '_' + (products[i].productId || products[i].id || Date.now());
                        }
                    }
                    return products;
                }

                function _getDialogParamsFromUrl() {
                    var params = {};
                    var search = $location.search();
                    if (search.catalogProduct) {
                        params.catalogProduct = search.catalogProduct;
                    }
                    if (search.product) {
                        params.product = search.product;
                    }
                    if (!params.catalogProduct && !params.product) {
                        var match = window.location.search.match(/[?&](catalogProduct|product)=([^&]+)/);
                        if (match) {
                            params[match[1]] = decodeURIComponent(match[2]);
                        }
                    }
                    return params;
                }

                function _buildStateParamsWithPage(page, dialogRouteParam) {
                    var params = angular.extend({}, $state.params, _getDialogParamsFromUrl());
                    if (dialogRouteParam && dialogRouteParam.paramName && dialogRouteParam.paramValue) {
                        params[dialogRouteParam.paramName] = dialogRouteParam.paramValue;
                    }
                    params.page = page;
                    return params;
                }

                function _isProductDialogOpen() {
                    var search = $location.search();
                    if (search.catalogProduct || search.product) {
                        return true;
                    }
                    return /[?&](catalogProduct|product)=/.test(window.location.search);
                }

                function _getEffectivePage() {
                    return Math.max(_currentPage || 1, _getPageFromUrl() || 1);
                }

                function _cancelPendingPageUrlUpdates() {
                    if (_urlPageSyncTimeout) {
                        $timeout.cancel(_urlPageSyncTimeout);
                        _urlPageSyncTimeout = null;
                    }
                    if (_urlUpdateTimer) {
                        $timeout.cancel(_urlUpdateTimer);
                        _urlUpdateTimer = null;
                    }
                }

                function _resetPaginationState() {
                    _cancelPendingPageUrlUpdates();
                    _currentPage = 1;
                    _deeplinkPage = 1;
                    _catalogOffsetBase = null;
                    _paginationChunkSize = null;
                    _isEmptyPreviousRequest = false;
                    _shouldScrollToPage = false;
                    delete $rootScope._categoryProductsPaginationPage;
                }

                function _clearPageFromStateAndUrl() {
                    if (parseInt($stateParams.page, 10) > 1) {
                        $state.go('.', angular.extend({}, $state.params, { page: null }), {
                            inherit: true,
                            notify: false,
                            location: 'replace'
                        });
                    }
                    if (_getPageFromUrl() > 1) {
                        _updateUrlPage(null);
                    }
                }

                function _syncPageToStateBeforeProductOpen() {
                    var effectivePage = _getEffectivePage();
                    if (effectivePage <= 1) {
                        return $q.resolve();
                    }
                    $rootScope._categoryProductsPaginationPage = effectivePage;
                    if (parseInt($stateParams.page, 10) === effectivePage) {
                        return $q.resolve();
                    }
                    return $state.go('.', _buildStateParamsWithPage(effectivePage), {
                        inherit: true,
                        notify: false,
                        location: 'replace'
                    });
                }

                function _restorePageAfterProductDialog() {
                    var effectivePage = Math.max(
                        $rootScope._categoryProductsPaginationPage || 1,
                        _currentPage,
                        _getPageFromUrl()
                    );
                    if (effectivePage <= 1) {
                        return;
                    }
                    _cancelPendingPageUrlUpdates();
                    $timeout(function() {
                        if (parseInt($stateParams.page, 10) !== effectivePage) {
                            $state.go('.', angular.extend({}, $state.params, { page: effectivePage }), {
                                inherit: true,
                                notify: false,
                                location: 'replace'
                            });
                        } else {
                            _updateUrlPage(effectivePage);
                        }
                    }, 0);
                }
                $rootScope.spMixPanel.trackProperties({
                    source: $rootScope.SP_SERVICES.SOURCES.CATEGORY_PAGE
                });
                angular.extend(categoryCtrl, {
                    products: [],
                    total: 0,
                    openProduct: openProduct,
                    category: (categories && categories.length) ? categories : {},

                    roboticBranchOrderSettings: roboticBranchOrderSettings,

                    productTagsFilter: FilterManager.getProductTagsFilter(_onChangeFilters, $scope, false),
                    brandFilter: FilterManager.getBrandsFilter(_onChangeFilters),
                    familiesFilter: FilterManager.getFamiliesFilter(_onChangeFilters),
                    supervisionsFilter: FilterManager.getSupervisionFilter(_onChangeFilters),
                    orderSorter: {
                        namesNgFilter: $filter('translate'),
                        title: 'Order items by',
                        defaultText: 'Select',
                        options: {
                            items: [
                                {
                                    name: 'Price high-low',
                                    field: 'branch.regularPrice',
                                    desc: true
                                },
                                {
                                    name: 'Price low-high',
                                    field: 'branch.regularPrice',
                                    desc: false
                                }
                            ]
                        },
                        onChange: _onChangeFilters
                    },
                    groupBy: {
                        titleStyleClass: 'family-group-title',
                        by: 'family.id',
                        value: 'family',
                        isOneColumn: '(names | name).long.length > 50',
                        templateUrl: 'template/views/category-products/partials/menu-family-group-title/index.html',
                        itemHeightRatio: '(names | name).short != (names | name).long ? 1.5 : 1'
                    }
                });

                categoryCtrl.events = $stateParams.events;
                $location.search('events', null);

                _initCategory();
                _initFilters();

                /**
                 * Initializes the filters and sort values and options
                 * @private
                 */
                function _isMenuCategory() {
                    return categoryCtrl.category._actualType == CATEGORIES_TYPES.MENU;
                }

                function _getSideMenuFilters(isMenuCategory) {
                    if (isMenuCategory) {
                        return [];
                    }

                    return [categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter];
                }

                function _getSideMenuFiltersToFinish(isMenuCategory) {
                    return isMenuCategory
                        ? [categoryCtrl.productTagsFilter]
                        : [categoryCtrl.productTagsFilter, categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter];
                }

                function _buildSideMenuFiltersParams(isMenuCategory ) {
                    var params = {
                        languageId: $rootScope.config.language.id,
                        names: []
                    };

                    angular.forEach(categories, function (category) {
                        angular.forEach(category.names, function (value) {
                            params.names.push(value);
                        });
                    });

                    var sideMenuFilters = _getSideMenuFilters(isMenuCategory);
                    FilterManager.parseFilters(params, sideMenuFilters);
                    return params;
                }

                function _applySideMenuFilters(results, isMenuCategory) {
                    FilterManager.applyCategoryProductsSideMenuFilters({
                        productTagsFilter: categoryCtrl.productTagsFilter,
                        brandFilter: categoryCtrl.brandFilter,
                        familiesFilter: categoryCtrl.familiesFilter,
                        supervisionsFilter: categoryCtrl.supervisionsFilter,
                        isMenuCategory: isMenuCategory,
                        results: results
                    });
                }

                function _loadSideMenuFilters(isMenuCategory) {
                    var sideMenuFiltersToFinish = _getSideMenuFiltersToFinish(isMenuCategory);

                    if (!categoryCtrl.category || !categoryCtrl.category.id) {
                        FilterManager.markFiltersAsFinished(sideMenuFiltersToFinish);
                        return $q.resolve();
                    }

                    return api.request({
                        url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products/filters',
                        params: _buildSideMenuFiltersParams(isMenuCategory)
                    }, {
                        fireAndForgot: true
                    }).then(function (results) {
                        _applySideMenuFilters(results, isMenuCategory);
                        return results;
                    }).finally(function () {
                        FilterManager.markFiltersAsFinished(sideMenuFiltersToFinish);
                    });
                }

                function _initFilters() {
                    if (_isMenuCategory()) {
                        _initMenuFilters();
                        return;
                    }

                    categoryCtrl.sorters = [categoryCtrl.orderSorter];
                    categoryCtrl.filters = [categoryCtrl.productTagsFilter, categoryCtrl.familiesFilter, categoryCtrl.brandFilter];
                    $rootScope.config.retailer.allowSupervisionFilter && (categoryCtrl.filters.push(categoryCtrl.supervisionsFilter));

                    FilterManager.setFiltersFromUrl({
                        productTag: categoryCtrl.productTagsFilter,
                        family: categoryCtrl.familiesFilter,
                        brand: categoryCtrl.brandFilter,
                        supervision: categoryCtrl.supervisionsFilter
                    }, $stateParams.filters, categoryCtrl.orderSorter, $stateParams.sort);

                    _loadSideMenuFilters(false);
                }

                function _initMenuFilters(){
                    categoryCtrl.sorters = null
                    categoryCtrl.filters = [categoryCtrl.productTagsFilter];
                    FilterManager.setFiltersFromUrl({
                        productTag: categoryCtrl.productTagsFilter,
                    }, $stateParams.filters, null, null);

                    _loadSideMenuFilters(true);
                }
                function openProduct(product, index) {
                    if (product.isBumper) {
                        return;
                    }

                    _cancelPendingPageUrlUpdates();

                    var itemsData = {
                        next: _nextProduct,
                        previous: _previousProduct,
                        siblings: [Items.items[index - 1], Items.items[index - 2], Items.items[index + 1], Items.items[index + 2]],
                        total: categoryCtrl.total,
                        index: index,
                        source: $rootScope.SP_SERVICES.SOURCES.CATEGORY_PAGE
                    };

                    return _syncPageToStateBeforeProductOpen().then(function() {
                        return util.openProduct(product, itemsData);
                    });
                }

                function _onChangeFilters() {
                    _resetPaginationState();

                    FilterManager.setFiltersToUrl({
                        productTag: categoryCtrl.productTagsFilter,
                        family: categoryCtrl.familiesFilter,
                        brand: categoryCtrl.brandFilter,
                        supervisions: categoryCtrl.supervisionsFilter
                    }, categoryCtrl.orderSorter);

                    // setFiltersToUrl inherits page from $stateParams; clear after filters are applied
                    $timeout(function() {
                        _clearPageFromStateAndUrl();
                    }, 0);

                    Items.resetItems();
                    categoryCtrl.products.splice(0, categoryCtrl.products.length);
                    return _loadSideMenuFilters(_isMenuCategory()).then(function () {
                        return _addChunkToProducts(true);
                    });
                }

                /**
                 * Update URL page parameter using history.replaceState to avoid triggering Angular $locationChange events.
                 * This prevents conflicts with dialog manager and other URL-dependent components.
                 * @param {number|null} page - The page number to set, or null to remove the page parameter
                 * @private
                 */
                function _updateUrlPage(page) {
                    if (_isProductDialogOpen()) {
                        return;
                    }
                    if (_urlUpdateTimer) {
                        $timeout.cancel(_urlUpdateTimer);
                    }
                    _urlUpdateTimer = $timeout(function() {
                        var currentUrl = window.location.href;
                        var newUrl;
                        if (!page || page <= 1) {
                            newUrl = currentUrl.replace(/([?&])page=[^&]*/g, function() {
                                return '';
                            });
                            newUrl = newUrl.replace(/\?&/, '?').replace(/&&/, '&');
                            if (newUrl.indexOf('?') === -1 && newUrl.indexOf('&') !== -1) {
                                newUrl = newUrl.replace('&', '?');
                            }
                            if (newUrl.charAt(newUrl.length - 1) === '?' || newUrl.charAt(newUrl.length - 1) === '&') {
                                newUrl = newUrl.substring(0, newUrl.length - 1);
                            }
                        } else {
                            if (/[?&]page=/.test(currentUrl)) {
                                newUrl = currentUrl.replace(/([?&]page=)[^&]*/, '$1' + page);
                            } else {
                                var separator = currentUrl.indexOf('?') !== -1 ? '&' : '?';
                                newUrl = currentUrl + separator + 'page=' + page;
                            }
                        }
                        if (newUrl !== currentUrl) {
                            window.history.replaceState(window.history.state, '', newUrl);
                        }
                        _urlUpdateTimer = null;
                    }, 200);
                }

                /**
                 * Shared ES query for category product chunks (append or prepend).
                 */
                function _buildCategoryProductsParams(from, requestedSize) {
                    var params = {
                        from: from,
                        size: requestedSize,
                        languageId: $rootScope.config.language.id,
                        minScore: 0
                    };

                    params.names = [];

                    angular.forEach(categories, function (category) {
                        angular.forEach(category.names, function (value) {
                            params.names.push(value);
                        });
                    });

                    FilterManager.parseFilters(params, [categoryCtrl.productTagsFilter, categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter]);

                    var sort = [],
                        categorySort = _getCategorySort();
                    if (categoryCtrl.category._actualType == CATEGORIES_TYPES.MENU) {
                        sort.push({'family.id': 'asc'});
                        if (!categorySort) {
                            sort.push({'localBarcode.raw': 'asc'});
                        } else {
                            params.categorySort = categorySort;
                        }
                    } else if (categoryCtrl.orderSorter.value) {
                        var paramsSort = {};
                        paramsSort[categoryCtrl.orderSorter.value.field] = categoryCtrl.orderSorter.value.desc ? 'desc' : 'asc';
                        sort = [paramsSort];
                    } else {
                        params.categorySort = categorySort;
                    }

                    if (sort.length) {
                        params.sort = sort;
                    }

                    if (Config.retailer.settings.showUnavailableProducts !== 'true') {
                        var filterJsonShowUnavailableProducts = {
                            "mustNot": {
                                "term": {
                                    "branch.isOutOfStock": true
                                }
                            }
                        };
                        if (params.filters) {
                            Object.assign(params.filters, filterJsonShowUnavailableProducts);
                        } else {
                            params.filters = filterJsonShowUnavailableProducts;
                        }

                    }
                    else {
                        var filterJson = {
                            "should": [
                                {
                                    "bool": {
                                        "must_not": {
                                            "exists": {
                                                "field": "branch.outOfStockShowUntilDate"
                                            }
                                        }
                                    }
                                },
                                {
                                    "bool": {
                                        "must": [
                                            {
                                                "range": {
                                                    "branch.outOfStockShowUntilDate": {
                                                        "gt": "now"
                                                    }
                                                }
                                            },
                                            {
                                                "term": {
                                                    "branch.isOutOfStock": true
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "bool": {
                                        "must": [
                                            {
                                                "term": {
                                                    "branch.isOutOfStock": false
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        };
                        if (Config.retailer.settings.isOutOfStockDuration === 'true') {
                            if (params.filters) {
                                params.filters.bool = filterJson;
                            } else {
                                params.filters = {"bool": filterJson};
                            }
                        }
                    }

                    return params;
                }

                function _addChunkToProducts(isInit) {
                    if ($rootScope.suggestionsDialogOpened) {
                        return;
                    }

                    var totalItems = Items.getItemsLength();
                    if (!isInit && (totalItems == categoryCtrl.total || categoryCtrl.total == categoryCtrl.products.length)) {
                        return;
                    }

                    if (!categoryCtrl.category || !categoryCtrl.category.id) {
                        categoryCtrl.total = 0;
                        return $q.resolve({products: [], total: 0});
                    }

                    return Items.getChunkAmount().then(function(size) {
                        if (_catalogOffsetBase === null) {
                            _catalogOffsetBase = (_deeplinkPage - 1) * size;
                        }
                        _paginationChunkSize = size;

                        var params = _buildCategoryProductsParams(_catalogOffsetBase + totalItems, size);

                        return Items.getItems({
                            url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products',
                            params: params
                        });
                    }).then(function (resp) {
                        var currentProductsCount = categoryCtrl.products.length;
                        var chunks = _assignUniqueIds(Items.insertBumpersToChunk(cart.getProducts(resp.products)));
                        if (_isRetailerPremiumReplacementsEnabled) {
                            var linesForSuggestions = [];
                            
                            angular.forEach(chunks, function (chunk) {

                                if (chunk && chunk.branch && chunk.branch.isOutOfStock) {
                                    linesForSuggestions.push(chunk);
                                }
                            });

                            if (linesForSuggestions.length) {
                                util.setReplacements(linesForSuggestions);
                            }

                        }
                        util.pushAll(categoryCtrl.products, chunks);
                        categoryCtrl.total = resp.total === 0 || resp.total ? resp.total : categoryCtrl.total;
                        util.setProductIndexPosition(resp.products);
                        DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: resp.products, data: {productsStartingPosition: currentProductsCount}});
                        
                        if (!isInit && resp.products.length > 0) {
                            _currentPage++;
                        } else if (isInit && _currentPage > 1 && resp.products.length > 0) {
                            _updateUrlPage(_currentPage);
                            
                            if (_shouldScrollToPage) {
                                var pageForScroll = _currentPage;
                                _shouldScrollToPage = false;
                                $timeout(function() {
                                    _scrollToPage(pageForScroll, true);
                                }, 1000);
                            }
                        }

                        if (isInit) {
                            _isInitialLoadComplete = true;
                        }

                        $timeout(function() {
                            _scheduleSyncVisiblePageToUrl(null, !isInit && resp.products.length > 0 ? 250 : 100);
                        }, 0);
                        
                        return resp;
                    });
                }

                /**
                 * Fetch products directly via API without using Items.getItems() to avoid
                 * side effects (Items service appends to Items.items array which is shared
                 * with categoryCtrl.products). For prepending, we need to fetch separately
                 * and manually unshift to the products array.
                 * @private
                 */
                function _fetchProductsForPrepend(from, size) {
                    var params = _buildCategoryProductsParams(from, size);
                    return api.request({
                        method: 'GET',
                        url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products',
                        params: params
                    });
                }

                function _prependChunkToProducts(domEvent) {
                    if (!_isInitialLoadComplete) {
                        return $q.resolve(null);
                    }
                    if ($rootScope.suggestionsDialogOpened || _prependInFlight || _isEmptyPreviousRequest) {
                        return $q.resolve(null);
                    }
                    if (!categoryCtrl.category || !categoryCtrl.category.id) {
                        return $q.resolve(null);
                    }
                    if (_catalogOffsetBase <= 0) {
                        _isEmptyPreviousRequest = true;
                        return $q.resolve(null);
                    }
                    if (Items.isChunkInProcess()) {
                        return $q.resolve(null);
                    }
                    if ($rootScope.endlessScrollCounter) {
                        return $q.resolve(null);
                    }

                    _prependInFlight = true;
                    var scrollEl = domEvent ? util.getDocumentScrolledElement(domEvent) : (document.scrollingElement || document.documentElement || document.body);
                    var oldScrollTop = scrollEl.scrollTop;
                    var oldScrollHeight = scrollEl.scrollHeight;

                    return Items.getChunkAmount().then(function(size) {
                        _paginationChunkSize = size;
                        var prevFrom = Math.max(0, _catalogOffsetBase - size);
                        var prevSize = _catalogOffsetBase - prevFrom;
                        
                        if (prevSize <= 0) {
                            _prependInFlight = false;
                            _isEmptyPreviousRequest = true;
                            return $q.resolve(null);
                        }
                        
                        return _fetchProductsForPrepend(prevFrom, prevSize).then(function(resp) {
                            if (!resp || !resp.products || !resp.products.length) {
                                _prependInFlight = false;
                                _isEmptyPreviousRequest = true;
                                return resp;
                            }

                            _catalogOffsetBase = prevFrom;

                            var productsToAdd = _assignUniqueIds(cart.getProducts(resp.products));
                            
                            if (_isRetailerPremiumReplacementsEnabled) {
                                var linesForSuggestions = [];
                                angular.forEach(productsToAdd, function (product) {
                                    if (product && product.branch && product.branch.isOutOfStock) {
                                        linesForSuggestions.push(product);
                                    }
                                });
                                if (linesForSuggestions.length) {
                                    util.setReplacements(linesForSuggestions);
                                }
                            }

                            Array.prototype.unshift.apply(categoryCtrl.products, productsToAdd);
                            
                            categoryCtrl.total = resp.total === 0 || resp.total ? resp.total : categoryCtrl.total;
                            util.setProductIndexPosition(categoryCtrl.products);
                            DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: resp.products, data: {productsStartingPosition: 0}});

                            $rootScope.$emit('items.prepended', {
                                chunk: resp, 
                                prependedCount: productsToAdd.length,
                                scrollAdjustment: {
                                    element: scrollEl,
                                    oldScrollTop: oldScrollTop,
                                    oldScrollHeight: oldScrollHeight
                                },
                                onComplete: function() {
                                    _prependInFlight = false;
                                    _scheduleSyncVisiblePageToUrl(scrollEl);
                                }
                            });

                            return resp;
                        });
                    }).catch(function() {
                        _prependInFlight = false;
                    });
                }

                /**
                 * Index of the product tile best representing "current scroll page": closest vertical mid to viewport center.
                 * Avoids treating only upper-viewport cells as visible (which broke page when scrolled near the list bottom).
                 */
                function _getViewportAnchorProductIndex(productElements) {
                    var vh = window.innerHeight;
                    var centerY = vh * 0.5;
                    var bestIdx = -1;
                    var bestDist = Infinity;
                    var i;
                    var r;
                    for (i = 0; i < productElements.length; i++) {
                        r = productElements[i].getBoundingClientRect();
                        if (r.bottom <= 0 || r.top >= vh) {
                            continue;
                        }
                        var midY = (r.top + r.bottom) * 0.5;
                        var dist = Math.abs(midY - centerY);
                        if (dist < bestDist) {
                            bestDist = dist;
                            bestIdx = i;
                        }
                    }
                    if (bestIdx >= 0) {
                        return bestIdx;
                    }
                    for (i = 0; i < productElements.length; i++) {
                        r = productElements[i].getBoundingClientRect();
                        if (r.bottom > 0 && r.top < vh) {
                            return i;
                        }
                    }
                    return -1;
                }

                function _syncVisiblePageToUrl(scrollEl) {
                    if (!$state.includes('app.categoryProducts') || _isProductDialogOpen()) {
                        return;
                    }
                    var chunkSize = _paginationChunkSize;
                    if (!chunkSize) {
                        Items.getChunkAmount().then(function(cs) {
                            _paginationChunkSize = cs;
                            _syncVisiblePageToUrl(scrollEl);
                        });
                        return;
                    }
                    if (!categoryCtrl.total) {
                        return;
                    }

                    var productElements = document.querySelectorAll('sp-items .item.product');
                    if (!productElements.length) {
                        return;
                    }

                    var visibleIdx = _getViewportAnchorProductIndex(productElements);
                    if (visibleIdx < 0) {
                        return;
                    }

                    var catalogIndex = _catalogOffsetBase + visibleIdx;
                    var page = Math.floor(catalogIndex / chunkSize) + 1;
                    var totalPages = Math.max(1, Math.ceil(categoryCtrl.total / chunkSize));
                    if (page > totalPages) {
                        page = totalPages;
                    }
                    if (page < 1) {
                        page = 1;
                    }

                    var urlPage = _getPageFromUrl();
                    if (page === urlPage) {
                        _currentPage = page;
                        return;
                    }

                    _currentPage = page;
                    $rootScope._categoryProductsPaginationPage = page;
                    _updateUrlPage(page);
                }

                function _scheduleSyncVisiblePageToUrl(scrollEl, delayMs) {
                    if (_urlPageSyncTimeout) {
                        $timeout.cancel(_urlPageSyncTimeout);
                    }
                    var wait = angular.isDefined(delayMs) ? delayMs : 100;
                    _urlPageSyncTimeout = $timeout(function() {
                        _urlPageSyncTimeout = null;
                        var el = scrollEl || (document.scrollingElement || document.documentElement || document.body);
                        _syncVisiblePageToUrl(el);
                    }, wait);
                }

                function _scrollToPage(pageNumber, deepLinkedSinglePage) {
                    return Items.getChunkAmount().then(function(chunkSize) {
                        var targetPageStartIndex = deepLinkedSinglePage ? 0 : chunkSize * (pageNumber - 1);
                        var productElements = document.querySelectorAll('sp-items .item.product');
                        
                        if (productElements && productElements.length > targetPageStartIndex) {
                            var targetElement = productElements[targetPageStartIndex];
                            if (targetElement) {
                                targetElement.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        } 
                    });
                }

                function _getCategorySort() {
                    var categorySorts = [];

                    var categoryWithSort = categories.find(function(node) {
                        return !!node.categorySort;
                    });
                    if (categoryWithSort && categoryWithSort.categorySort) {
                        angular.forEach(categoryWithSort.categorySort, function(categorySortItem) {
                            categorySorts.push({
                                sortType: categorySortItem.sortType,
								topPriority: categorySortItem.topPriority && (angular.toJson(JSON.parse(categorySortItem.topPriority).map(function(x) {
									return {id: x.id};
								})))
                            });
                        });
                    }

                    var userPurchasesSortBoost = User.getPurchasesSortBoost();
                    if (userPurchasesSortBoost) {
                        categorySorts.push(userPurchasesSortBoost);
                    }

                    var productTagsSortBoost = FilterManager.getProductTagsSortBoost(categoryCtrl.productTagsFilter);
                    if (productTagsSortBoost) {
                        categorySorts.push(productTagsSortBoost);
                    }

                    if (categorySorts.length) {
                        return categorySorts;
                    }
                }

                function _nextProduct(index) {
                    var totalItemsWithoutBumpers = Items.getItemsLength(),
                        nextProductData = Items.getNextProductData(index, 1);
                    if (categoryCtrl.total != totalItemsWithoutBumpers && !nextProductData.product) {
                        return _addChunkToProducts().then(function () {
                            return _nextProduct(index);
                        });
                    }

                    nextProductData.total = Items.items.length + categoryCtrl.total - totalItemsWithoutBumpers;
                    return $q.resolve(nextProductData);
                }

                function _previousProduct(index) {
                    var nextProductData = Items.getNextProductData(index, -1);
                    nextProductData.total = Items.items.length + categoryCtrl.total - Items.getItemsLength();
                    return $q.resolve(nextProductData);
                }

                function _initCategory() {
                    var actualType;
                    if (categories && angular.isArray(categories) && categories.length) {
                        categoryCtrl.category = categories[0];

                        DataLayer.push(DataLayer.EVENTS.SELECT_CONTENT, {data: {category: 'Menu', action: 'Click', label: categoryCtrl.category.names}});

                        //for tests
                        //categoryCtrl.category.type = categoryCtrl.category.id == 78067 ? CATEGORIES_TYPES.MENU : categoryCtrl.category.type;
                        var imageUrl;
                        for (var i = 0; i < categories.length; i++) {
                            if (!imageUrl && !!categories[i].siteImage) {
                                imageUrl = categories[i].siteImage;
                            }
                            if (!actualType && !!categories[i].type && categories[i].type != CATEGORIES_TYPES.INHERIT) {
                                actualType = categories[i].type;
                            }

                            if (imageUrl && actualType) break;
                        }
                        categoryCtrl.category._siteImage = imageUrl || (categories[categories.length - 1].imageUrl || '').replace('normal', 'big');

                        util.setCurrentCategory(categories, $scope);
                    } else {
                        if (!categoryCtrl.category || angular.equals(categoryCtrl.category, {})) {
                            categoryCtrl.category = {
                                id: $stateParams.cid,
                                names: {},
                                _siteImage: ''
                            };
                        }
                        actualType = categoryCtrl.category.type;
                        util.setCurrentCategory(categoryCtrl.category, $scope);
                    }
                    categoryCtrl.category._actualType = actualType || CATEGORIES_TYPES.REGULAR;

                    if (categoryCtrl.category && !angular.equals(categoryCtrl.category, {})) {
                        _checkSubCategoriesType(categoryCtrl.category);
                    }
                }

                function _checkSubCategoriesType(category) {
                    if (categoryCtrl.category._actualType != CATEGORIES_TYPES.MENU) return;

                    if (category.type == CATEGORIES_TYPES.REGULAR) {
                        return categoryCtrl.category._actualType = CATEGORIES_TYPES.REGULAR;
                    }

                    angular.forEach(category.subCategories || [], _checkSubCategoriesType);
                }

                /**Listeners*/
                util.currentScopeListener($scope, $rootScope.$on('document.scroll', function(angularEvent, domEvent) {
                    if (!$state.includes('app.categoryProducts')) {
                        return;
                    }
                    var scrollEl = domEvent ? util.getDocumentScrolledElement(domEvent) : (document.scrollingElement || document.documentElement || document.body);
                    var currentScrollTop = scrollEl.scrollTop;
                    var isScrollingUp = currentScrollTop < _lastScrollTop;
                    
                    if (isScrollingUp && currentScrollTop < _TOP_SCROLL_LOAD_THRESHOLD && 
                        _catalogOffsetBase > 0 && !_prependInFlight && !_isEmptyPreviousRequest &&
                        !$rootScope.endlessScrollCounter && !$rootScope.suggestionsDialogOpened) {
                        _prependChunkToProducts(domEvent);
                    }
                    
                    _lastScrollTop = currentScrollTop;
                    _scheduleSyncVisiblePageToUrl(scrollEl);
                }));

                util.currentScopeListener($scope, $rootScope.$on('items.initiated', function () {
                    _addChunkToProducts(true);
                }));

                util.currentScopeListener($scope, $rootScope.$on('cart.lines.add', function (event, data) {
                    if (categoryCtrl.products.length && categoryCtrl.events) {
                        util.firePromotionEvent(categoryCtrl.events[ADVERTISEMENT_CONVERSION_TYPE.ADD_TO_CART]);
                        if (data.lines && data.lines.length) {
                            data.lines[0].adConversionUrl = categoryCtrl.events[ADVERTISEMENT_CONVERSION_TYPE.CHARGE];
                        }
                    }
                    angular.forEach(categoryCtrl.products, function (product, index) {
                        if (product.isBumper) return;
                        categoryCtrl.products[index] = cart.getProduct(product);
                    });
                }));

                util.currentScopeListener($scope, $rootScope.$on('document.scroll.end', function (data, event) {
                    event.start();
                    var promise = _addChunkToProducts();
                    if (promise) {
                        promise.finally(function () {
                            event.done();
                        });
                    } else {
                        event.done();
                    }
                }));
                util.currentScopeListener($scope, $rootScope.$on('items.add', function () {
                    _addChunkToProducts();
                }));

                util.currentScopeListener($scope, $rootScope.$on('dialogUrlManager.routeChanged', function(event, routeData) {
                    if (!routeData) {
                        return;
                    }
                    if (routeData.newParam &&
                        (routeData.newParam.paramName === 'catalogProduct' || routeData.newParam.paramName === 'product')) {
                        _cancelPendingPageUrlUpdates();
                        var openPage = _getEffectivePage();
                        $rootScope._categoryProductsPaginationPage = openPage;
                        if (openPage > 1 && parseInt($stateParams.page, 10) !== openPage) {
                            $state.go('.', _buildStateParamsWithPage(openPage, routeData.newParam), {
                                inherit: true,
                                notify: false,
                                location: 'replace'
                            });
                        }
                        return;
                    }
                    if (!routeData.newParam && routeData.oldParam &&
                        (routeData.oldParam.paramName === 'catalogProduct' || routeData.oldParam.paramName === 'product')) {
                        _restorePageAfterProductDialog();
                    }
                }));

                if (_isCategorySwitch) {
                    $timeout(function() {
                        _clearPageFromStateAndUrl();
                    }, 0);
                }

                util.currentScopeListener($scope, $scope.$on('$destroy', function () {
                    if (_urlPageSyncTimeout) {
                        $timeout.cancel(_urlPageSyncTimeout);
                    }
                    if (_urlUpdateTimer) {
                        $timeout.cancel(_urlUpdateTimer);
                    }
                    delete $rootScope._categoryProductsPaginationPage;
                }));
            }])

        //those controllers should move to their template
        .controller('PrutahTemplateCategoryProductsCtrl', ['$scope', 'Items', 'CATEGORIES_TYPES', 'SP_ITEMS_DESIGNS', function($scope, Items, CATEGORIES_TYPES, SP_ITEMS_DESIGNS) {
            var categoryCtrl = $scope.categoryCtrl;

            Items.initPage({
                defaultWidth: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS ? 370 : 210,
                design: categoryCtrl.category._actualType === CATEGORIES_TYPES.MENU && SP_ITEMS_DESIGNS.MENU,
                isSingleBumper: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS
            });
        }])
        .controller('KikarTemplateCategoryProductsCtrl', ['$scope', 'Items', 'CATEGORIES_TYPES', 'SP_ITEMS_DESIGNS', function($scope, Items, CATEGORIES_TYPES, SP_ITEMS_DESIGNS) {
            var categoryCtrl = $scope.categoryCtrl;
            Items.initPage({
                defaultWidth: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS ? 350 : 235,
                design: categoryCtrl.category._actualType === CATEGORIES_TYPES.MENU && SP_ITEMS_DESIGNS.MENU,
                isSingleBumper: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS
            });
        }]);
})(angular, app);
